export default __webpack_public_path__ + "static/media/thumbnail.ea980af9.webp";